/**
 * Auto-generated from dark-roast enum types — string-literal union types
 * derived from the Java backend's wire enum values. Do not edit manually.
 * Regenerate with: yarn sync-entities
 */

export enum LanguageSkill {
  Speaking = "speaking",
  Reading = "reading",
  Writing = "writing",
}

export const LanguageSkillDisplay: Record<LanguageSkill, string> = {
  [LanguageSkill.Speaking]: "Speaking",
  [LanguageSkill.Reading]: "Reading",
  [LanguageSkill.Writing]: "Writing",
};
